import { durationFirstPluralHours } from '../strings.locstring.json';
import { durationHour } from './formatEndTime.locstring.json';
import loc, { format } from 'owa-localize';
import { differenceInMinutes, OwaDate } from 'owa-datetime';

/**
 * Formats the end time reflecting to also include the duration of the event
 * @param endTime
 * @param startTime
 */
export default function formatEndTime(endTime: OwaDate, startTime: OwaDate) {
    const diff = differenceInMinutes(endTime, startTime) / 60;
    const diffInHours = Number(diff.toFixed(2));

    const endTimeWithDuration: string =
        diffInHours <= 1
            ? format(loc(durationHour), diffInHours)
            : format(loc(durationFirstPluralHours), diffInHours);

    return endTimeWithDuration;
}
